<!-- Modal -->
<template>
	<!-- Modal -->
	<div
		class="modal fade"
		id="mediaLibraryModal"
		tabindex="-1"
		aria-labelledby="mediaLibraryModalLabel"
		aria-hidden="true"
		data-bs-backdrop="true"
	>
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header align-items-start">
					<div>
						<h5 class="modal-title" id="mediaLibraryModalLabel">Media Library</h5>
						<p>A complete list of the files located on your site</p>
					</div>

					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<!-- Search Files -->
					<div class="tw-table-search-wrapper col-12">
						<input type="search" class="form-control" v-model="querySearch" placeholder="Search files" />
					</div>
					<!-- Upload File -->
					<div class="col-12 text-end mt-2">
						<label for="media" class="d-flex align-items-center justify-content-end"
							><span class="btn border btn-default"
								><i class="far fa-image"></i> Add Media File</span
							></label
						>
						<input type="file" class="d-none" id="media" @change="handleFileUploads($event)" multiple />
					</div>

					<!-- Media Library Table -->
					<div
						v-if="!requestResolved"
						class="tw-table-loading-overlay pt-5 d-flex align-items-start justify-content-center position-absolute top-0 bottom-0 start-0 end-0 bg-white opacity-75 tw-light-grey-bg-color"
						:class="!mediaLibrary.length && 'bg-transparent'"
					>
						<i class="fa fa-spinner fa-pulse fa-4x border-0"></i>
					</div>
					<table class="table table-responsive table-hover">
						<thead>
							<tr>
								<td>File</td>
								<td>Name</td>
								<td>Date</td>
								<td>Type</td>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="file in mediaLibrary"
								:key="file.id"
								class="cursor-pointer"
								@click="insertMedia(file.source_url)"
							>
								<td>
									<img
										v-if="file.media_type == 'image'"
										:src="thumbSrc(file)"
										height="53"
										width="55"
									/>
									<span v-else class="d-flex align-items-center">
										<span v-html="defaultImage"></span>
									</span>
								</td>
								<td class="align-middle">{{ file.name }}</td>
								<td class="align-middle">{{ file.date }}</td>
								<td class="align-middle">{{ file.media_type }}</td>
							</tr>
							<tr v-if="mediaLibrary.length < 1">
								<td colspan="6" class="text-center">There are no files for this client</td>
							</tr>
						</tbody>
					</table>
					<!-- #Media Library Table -->
					<Pagination
						:totalItems="numberOfMedia"
						:currentPage="page"
						:perPage="perPage"
						@pageChanged="setPage"
						:goButton="false"
						styled="centered"
						borderActiveColor=""
						borderTextActiveColor="text-white"
						:paginationDisabled="!requestResolved"
					/>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import juniperMixin from '@/mixins/juniperMixin'
import Pagination from '@/components/juniper/media/MediaLibraryPagination'

export default {
	name: 'MediaLibraryModal',
	components: {
		Pagination,
	},
	data: () => ({
		mediaLibrary: {},
		requestResolved: false,
		perPage: 5,
		page: 1,
		numberOfMedia: 0,
		numberOfPages: 0,
		querySearch: '',
		order: 'desc',
		orderBy: 'date',
		defaultImage: '<div class="tw-defaul-featured-img bg-white border"><i class="fas fa-file"></i></div>',
		selected: 0,
		requestingFile: false,
		allowMulti: false,
		onlyImageType: true,
		$mediaModal: null,
		clientId: null,
	}),
	mounted() {
		this.clientId = this.$route.params.id
		this.setMediaLibrary()
	},
	watch: {
		page: function() {
			this.setMediaLibrary()
		},
		querySearch: function() {
			this.setMediaLibrary()
		},
		orderBy: function() {
			this.setMediaLibrary()
		},
		order: function() {
			this.setMediaLibrary()
		},
	},
	methods: {
		async setMediaLibrary() {
			this.requestResolved = false
			let res = await this.getMediaLibrary(
				this.page,
				this.perPage,
				this.order,
				this.orderBy,
				this.querySearch,
				this.onlyImageType,
				false,
				this.clientId
			)

			if (res && res.status === 200) {
				this.requestResolved = true
				this.mediaLibrary = res.data || []
				this.numberOfShowedMedia = this.mediaLibrary.length
				this.numberOfMedia = parseInt(res.headers['x-wp-total'])
				this.numberOfPages = parseInt(res.headers['x-wp-totalpages'])

				let self = this

				this.mediaLibrary.forEach(function(media, index) {
					self.mediaLibrary[index].filename = media.source_url.split('/').pop()
				})
			}
		},

		async handleFileUploads(event) {
			let clientId = this.$route.params.id
			this.requestResolved = false
			let files = Array.from(event.target.files)
			let self = this
			await Promise.all(
				files.map(async function(file) {
					await self.uploadFile(file, clientId)
				})
			)
			this.setMediaLibrary()
		},

		insertMedia(mediaUrl) {
			this.$emit('mediaInsert', mediaUrl)
		},

		thumbSrc(file) {
			return file.media_details?.sizes?.thumbnail?.source_url || file.source_url
		},

		mediaLibOpen(value, requestingFile, allowMulti, onlyImageType = false) {
			if (value) {
				this.requestingFile = requestingFile // if not inserting into tinymce editor then it's this
				this.allowMulti = allowMulti
				this.onlyImageType = onlyImageType
				this.setMediaLibrary()
			}
		},

		setPage(n) {
			this.page = n
		},

		setOrder(orderBy) {
			if (this.orderBy != orderBy) {
				this.order = 'desc'
			} else if (this.orderBy == orderBy && this.order == 'desc') {
				this.order = 'asc'
			} else if (this.orderBy == orderBy && this.order == 'asc') {
				this.order = 'desc'
			}
			this.orderBy = orderBy
		},
	},
	mixins: [juniperMixin],
	emits: ['mediaInsert'],
}
</script>
<style>
#mediaLibraryModal.modal {
	z-index: 1060 !important;
}
#mediaLibraryModal ~ .modal-backdrop {
	z-index: 1059 !important;
}
</style>
